export { default as NewPayerMix } from './NewPayerMix';
